// extracted by mini-css-extract-plugin
module.exports = {"pagination":"az_QR","prev":"az_RR","next":"az_SR","liStyle":"az_TR","listStyle":"az_UR"};